import { render, staticRenderFns } from "./ResponsibilityIcon.vue?vue&type=template&id=02a3dcd6&scoped=true"
import script from "./ResponsibilityIcon.vue?vue&type=script&lang=js"
export * from "./ResponsibilityIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a3dcd6",
  null
  
)

export default component.exports